import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'homepage.faq.heading',
		defaultMessage: 'Frequently Asked Questions',
		description: 'Heading for the FAQ section on the homepage',
	},
});
